(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jacques-gift-bundle"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jacques-gift-bundle')) {
    customElements.define(
      'jacques-gift-bundle',
      class JacquesGiftBundle extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('.ts-jdm-gift__button');
          this.buttonLabel = this.button?.querySelector('span');
          this.status = this.querySelector('.ts-jdm-gift__status');
          this.defaultLabel = this.buttonLabel?.textContent || '';
          this.previewTrigger = this.querySelector('.ts-jdm-gift__product--preview');
          this.previewDialog = this.querySelector('.ts-jdm-gift__modal');
          this.previewClose = this.querySelector('.ts-jdm-gift__modal-close');

          if (this.button) this.button.addEventListener('click', () => this.addBundle());
          if (this.previewTrigger) this.previewTrigger.addEventListener('click', () => this.openPreview());
          if (this.previewClose) this.previewClose.addEventListener('click', () => this.previewDialog?.close());
          if (this.previewDialog) {
            this.previewDialog.addEventListener('click', (event) => this.closePreviewFromBackdrop(event));
          }
        }

        openPreview() {
          if (this.previewDialog && typeof this.previewDialog.showModal === 'function') {
            this.previewDialog.showModal();
          }
        }

        closePreviewFromBackdrop(event) {
          if (event.target !== this.previewDialog) return;

          const bounds = this.previewDialog.getBoundingClientRect();
          const isOutside =
            event.clientX < bounds.left ||
            event.clientX > bounds.right ||
            event.clientY < bounds.top ||
            event.clientY > bounds.bottom;

          if (isOutside) this.previewDialog.close();
        }

        async addBundle() {
          if (!this.button || this.button.getAttribute('aria-busy') === 'true') return;

          const watchForm = document.getElementById(this.dataset.watchFormId);
          const watchVariantInput = watchForm?.querySelector('[name="id"]');
          const quantityInput = watchForm?.querySelector('[name="quantity"]');
          const watchVariantId = Number(watchVariantInput?.value);
          const giftVariantId = Number(this.dataset.giftVariantId);
          const quantity = Math.max(1, Number(quantityInput?.value) || 1);

          if (!watchVariantId || !giftVariantId) {
            this.showError();
            return;
          }

          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          const root = window.Shopify?.routes?.root || '/';
          const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
          const sectionIds = cart?.getSectionsToRender?.().map((section) => section.id) || [];
          const payload = {
            items: [
              { id: watchVariantId, quantity },
              {
                id: giftVariantId,
                quantity: 1,
                properties: { _bundle: 'Jacques Du Manoir Gift Edition' },
              },
            ],
          };

          if (sectionIds.length) {
            payload.sections = sectionIds.join(',');
            payload.sections_url = normalizedRoot;
          }

          this.button.setAttribute('aria-busy', 'true');
          this.button.disabled = true;
          this.buttonLabel.textContent = this.dataset.addingLabel;
          this.status.textContent = '';
          cart?.setActiveElement?.(this.button);

          try {
            const response = await fetch(`${normalizedRoot}cart/add.js`, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(payload),
            });
            const data = await response.json();

            if (!response.ok || data.status) {
              throw new Error(data.description || data.message || this.dataset.errorLabel);
            }

            this.buttonLabel.textContent = this.dataset.addedLabel;

            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
              await window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'jacques-gift-bundle',
                productVariantId: watchVariantId,
                cartData: data,
              });
            }

            if (cart?.renderContents && data.sections) {
              cart.classList.remove('is-empty');
              cart.renderContents(data);
            } else {
              window.location.assign(window.routes?.cart_url || `${normalizedRoot}cart`);
            }
          } catch (error) {
            this.status.textContent = error?.message || this.dataset.errorLabel;
            this.buttonLabel.textContent = this.defaultLabel;
          } finally {
            this.button.removeAttribute('aria-busy');
            this.button.disabled = false;
          }
        }

        showError() {
          if (this.status) this.status.textContent = this.dataset.errorLabel;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ts-sticky-product-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ts-sticky-product-bar')) {
    customElements.define(
      'ts-sticky-product-bar',
      class TsStickyProductBar extends HTMLElement {
        connectedCallback() {
          this.mainButton = document.getElementById(this.dataset.mainButtonId);
          this.mainPrice = document.getElementById(this.dataset.mainPriceId);
          this.stickyButton = this.querySelector('[data-ts-sticky-submit]');
          this.stickyLabel = this.querySelector('[data-ts-sticky-label]');
          this.stickyPrice = this.querySelector('[data-ts-sticky-price]');
          this.stickyStatus = this.querySelector('[data-ts-sticky-status]');
          this.stickyStatusLabel = this.querySelector('[data-ts-sticky-status-label]');
          this.pageFooter =
            document.getElementById('shopify-section-newsletter-social') ||
            document.getElementById('shopify-section-TS_Custom_Footer') ||
            document.querySelector('footer.footer, footer');
          this.stickyHeader = document.querySelector('.section-header');

          if (!this.mainButton || !this.stickyButton) {
            this.remove();
            return;
          }

          this.onStickyClick = () => {
            if (this.stickyButton.disabled) return;
            this.mainButton.click();
          };

          this.scheduleVisibilityUpdate = () => {
            if (this.visibilityFrame) return;
            this.visibilityFrame = requestAnimationFrame(() => {
              this.visibilityFrame = null;
              this.updateVisibility();
            });
          };

          this.setupFooterDockedBar();

          this.stickyButton.addEventListener('click', this.onStickyClick);
          this.dockedButton?.addEventListener('click', this.onStickyClick);
          window.addEventListener('scroll', this.scheduleVisibilityUpdate, { passive: true });
          window.addEventListener('resize', this.scheduleVisibilityUpdate, { passive: true });
          window.visualViewport?.addEventListener('resize', this.scheduleVisibilityUpdate, { passive: true });

          if ('ResizeObserver' in window) {
            this.layoutObserver = new ResizeObserver(this.scheduleVisibilityUpdate);
            this.layoutObserver.observe(document.documentElement);
            this.layoutObserver.observe(document.body);

            const mainContent = document.getElementById('MainContent');
            if (mainContent) this.layoutObserver.observe(mainContent);
          }

          if (this.pageFooter && 'IntersectionObserver' in window) {
            this.footerObserver = new IntersectionObserver(this.scheduleVisibilityUpdate, {
              threshold: [0, 0.01, 0.25, 0.5, 0.75, 1],
            });
            this.footerObserver.observe(this.footerDockedBar || this.pageFooter);
          }

          if (this.stickyHeader) {
            this.headerObserver = new MutationObserver(this.scheduleVisibilityUpdate);
            this.headerObserver.observe(this.stickyHeader, {
              attributes: true,
              attributeFilter: ['class', 'style'],
            });
          }

          this.buttonObserver = new MutationObserver(() => this.syncButton());
          this.buttonObserver.observe(this.mainButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
            childList: true,
            subtree: true,
          });

          if (this.mainPrice) {
            this.priceObserver = new MutationObserver(() => this.syncPrice());
            this.priceObserver.observe(this.mainPrice, {
              attributes: true,
              childList: true,
              subtree: true,
            });
          }

          this.syncButton();
          this.syncPrice();
          this.updateVisibility();
        }

        disconnectedCallback() {
          this.stickyButton?.removeEventListener('click', this.onStickyClick);
          this.dockedButton?.removeEventListener('click', this.onStickyClick);
          window.removeEventListener('scroll', this.scheduleVisibilityUpdate);
          window.removeEventListener('resize', this.scheduleVisibilityUpdate);
          window.visualViewport?.removeEventListener('resize', this.scheduleVisibilityUpdate);
          this.buttonObserver?.disconnect();
          this.priceObserver?.disconnect();
          this.layoutObserver?.disconnect();
          this.footerObserver?.disconnect();
          this.headerObserver?.disconnect();
          if (this.ownsFooterDockedBar) this.footerDockedBar?.remove();
          if (this.visibilityFrame) cancelAnimationFrame(this.visibilityFrame);
          if (this.handoffFrame) cancelAnimationFrame(this.handoffFrame);
        }

        syncButton() {
          const mainLabel = this.mainButton.querySelector('span');
          const labelText = mainLabel?.textContent?.trim();
          const isLoading = this.mainButton.classList.contains('loading');
          const isDisabled =
            this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true' || isLoading;
          const isUnavailable = !isLoading && isDisabled;

          if (labelText) this.stickyLabel.textContent = labelText;
          this.stickyButton.disabled = isDisabled;
          this.stickyButton.setAttribute('aria-busy', String(isLoading));
          this.classList.toggle('is-loading', isLoading);

          if (this.dockedButton) {
            if (labelText && this.dockedLabel) this.dockedLabel.textContent = labelText;
            this.dockedButton.disabled = isDisabled;
            this.dockedButton.setAttribute('aria-busy', String(isLoading));
            this.footerDockedBar.classList.toggle('is-loading', isLoading);
          }

          if (!isLoading && this.stickyStatus && this.stickyStatusLabel) {
            this.stickyStatus.classList.toggle('is-unavailable', isUnavailable);
            this.stickyStatusLabel.textContent = isUnavailable
              ? this.stickyStatus.dataset.unavailableLabel
              : this.stickyStatus.dataset.availableLabel;

            if (this.dockedStatus && this.dockedStatusLabel) {
              this.dockedStatus.classList.toggle('is-unavailable', isUnavailable);
              this.dockedStatusLabel.textContent = isUnavailable
                ? this.dockedStatus.dataset.unavailableLabel
                : this.dockedStatus.dataset.availableLabel;
            }
          }
        }

        syncPrice() {
          if (!this.mainPrice || !this.stickyPrice) return;

          const salePrice = this.mainPrice.querySelector('.price--on-sale .price-item--sale, .price--on-sale .price-item--last');
          const regularPrice = this.mainPrice.querySelector('.price__regular .price-item--regular, .price-item--regular');
          const activePrice = salePrice || regularPrice;
          const priceText = activePrice?.textContent?.trim();

          if (priceText) this.stickyPrice.textContent = priceText;
          this.stickyPrice.classList.toggle('is-sale', Boolean(salePrice));

          if (this.dockedPrice) {
            if (priceText) this.dockedPrice.textContent = priceText;
            this.dockedPrice.classList.toggle('is-sale', Boolean(salePrice));
          }
        }

        setupFooterDockedBar() {
          if (!this.pageFooter?.parentElement) return;

          const previousElement = this.pageFooter.previousElementSibling;
          const existingDockedBar = previousElement?.matches('[data-ts-sticky-product-dock-space]')
            ? previousElement
            : null;

          this.footerDockedBar = existingDockedBar || document.createElement('div');
          this.ownsFooterDockedBar = !existingDockedBar;

          if (this.ownsFooterDockedBar) {
            this.footerDockedBar.className = 'ts-sticky-product-bar__dock-space';
            this.footerDockedBar.dataset.tsStickyProductDockSpace = '';
            this.footerDockedBar.setAttribute('aria-hidden', 'true');

            const dockedInner = this.querySelector('.ts-sticky-product-bar__inner')?.cloneNode(true);
            if (dockedInner) this.footerDockedBar.append(dockedInner);

            this.pageFooter.before(this.footerDockedBar);
          }

          this.dockedButton = this.footerDockedBar.querySelector('[data-ts-sticky-submit]');
          this.dockedLabel = this.footerDockedBar.querySelector('[data-ts-sticky-label]');
          this.dockedPrice = this.footerDockedBar.querySelector('[data-ts-sticky-price]');
          this.dockedStatus = this.footerDockedBar.querySelector('[data-ts-sticky-status]');
          this.dockedStatusLabel = this.footerDockedBar.querySelector('[data-ts-sticky-status-label]');
        }

        getVisibleHeaderBottom() {
          if (!this.stickyHeader) return 0;

          const headerRect = this.stickyHeader.getBoundingClientRect();
          const headerStyle = window.getComputedStyle(this.stickyHeader);
          const viewportHeight = window.visualViewport?.height || window.innerHeight;
          const isRendered = headerStyle.display !== 'none' && headerStyle.visibility !== 'hidden';
          const isVisiblyOnScreen = headerRect.bottom > 0 && headerRect.top < viewportHeight;
          const isRevealing =
            this.stickyHeader.classList.contains('scrolled-past-header') &&
            !this.stickyHeader.classList.contains('shopify-section-header-hidden') &&
            !this.stickyHeader.classList.contains('ts-header-is-hiding');

          if (!isRendered || (!isVisiblyOnScreen && !isRevealing)) return 0;

          const intendedHeaderBottom = isRevealing ? this.stickyHeader.offsetHeight : 0;
          return Math.min(viewportHeight, Math.max(0, headerRect.bottom, intendedHeaderBottom));
        }

        isFooterDockedBarInPlace() {
          if (!this.footerDockedBar) return false;

          const dockRect = this.footerDockedBar.getBoundingClientRect();
          const viewportBottom = window.visualViewport
            ? window.visualViewport.offsetTop + window.visualViewport.height
            : window.innerHeight;

          return dockRect.bottom <= viewportBottom + 0.5;
        }

        updateBarMode(shouldShow) {
          const nextMode = shouldShow ? (this.isFooterDockedBarInPlace() ? 'docked' : 'fixed') : 'hidden';
          const isCrossingDockPoint =
            (this.barMode === 'fixed' && nextMode === 'docked') ||
            (this.barMode === 'docked' && nextMode === 'fixed');

          if (isCrossingDockPoint) {
            this.classList.add('is-footer-handoff');
            this.footerDockedBar?.classList.add('is-footer-handoff');
          }

          this.classList.toggle('is-visible', nextMode === 'fixed');
          this.setAttribute('aria-hidden', String(nextMode !== 'fixed'));
          this.footerDockedBar?.classList.toggle('is-visible', nextMode === 'docked');
          this.footerDockedBar?.setAttribute('aria-hidden', String(nextMode !== 'docked'));

          if (nextMode === 'fixed') this.stickyButton.removeAttribute('tabindex');
          else this.stickyButton.setAttribute('tabindex', '-1');

          if (this.dockedButton) {
            if (nextMode === 'docked') this.dockedButton.removeAttribute('tabindex');
            else this.dockedButton.setAttribute('tabindex', '-1');
          }

          this.barMode = nextMode;

          if (isCrossingDockPoint) {
            if (this.handoffFrame) cancelAnimationFrame(this.handoffFrame);
            this.handoffFrame = requestAnimationFrame(() => {
              this.handoffFrame = requestAnimationFrame(() => {
                this.classList.remove('is-footer-handoff');
                this.footerDockedBar?.classList.remove('is-footer-handoff');
                this.handoffFrame = null;
              });
            });
          }
        }

        updateVisibility() {
          const buttonRect = this.mainButton.getBoundingClientRect();
          const headerBottom = this.getVisibleHeaderBottom();
          const hasPassedMainButton = buttonRect.top < headerBottom + 12;
          const hasBlockingDialog = Boolean(
            document.querySelector('.product-media-modal[open], quick-add-modal[open], cart-drawer.active')
          );
          const shouldShow = hasPassedMainButton && !hasBlockingDialog;

          this.updateBarMode(shouldShow);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
